<div class="row">
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
    <div class="mar0">
      <div class="card bg-c-white order-card customCard">
        <div class="card-block">
          <h6 class="m-b-20" style="color: rgb(3, 25, 139);font-weight: 500;"><b>PAF</b>
            <i style="position: relative;float: right;display: flex;" class="fa "
              [ngClass]="coursesEnable ? 'fa-compress': ' fa-expand'" aria-hidden="true"
              title="{{ !coursesEnable ? 'Expand' : 'Collapse' }}" (click)="toggleFullscreen('overallEnable')"></i>
          </h6>
          <!-- <div class="skeleton" *ngIf="isDataLoaded == 0">
                  <div class="skeleton-body">
                    <div class="skeleton-row">
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                      <div class="skeleton-poll"></div>
                    </div>
                  </div>
                </div> -->
          <div>
            <kendo-chart [style.width.%]="100" [ngClass]="coursesEnable ? 'cardHeight600': ''">
              <kendo-chart-area background="#fff"></kendo-chart-area>
              <kendo-chart-series-defaults type="bar" [gap]="0.50" [stack]="true">
                <kendo-chart-series-defaults-labels format="labelFormat" [visual]="labelVisual">
                </kendo-chart-series-defaults-labels>
              </kendo-chart-series-defaults>
              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="categorieList">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-series>
                <kendo-chart-series-item type="bar" [data]="pfaDataList" field="no_of_Reviews" categoryField="division"
                  [name]="totalName">
                </kendo-chart-series-item>
              </kendo-chart-series>
              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="categorieList" [labels]="{ rotation: 'auto', step: 1 }"
                  [majorGridLines]="{ visible: false }">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-legend position="bottom" [visible]="true" [labels]="{color: 'rgb(3, 25, 139)'}"
                [markers]="{height: 15,width:27}"></kendo-chart-legend>
            </kendo-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
    <div class="card bg-c-white order-card customCard">
      <div class="card-block">
        <div [ngClass]="{ 'kgrid-fullscreen': enableFullscreen }">
          <kendo-grid #docGrid id="pfaGridDataList" [height]="400" [pageSize]="pageSize" [sortable]="true"
            [resizable]="true" [filterable]="enableFilter" [navigable]="true" [reorderable]="true" [pageable]="true"
            [scrollable]="true" [kendoGridBinding]="pfaGridDataList"
            class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
            <ng-template kendoPagerTemplate>
              <div class="d-flex w-100 justify-content-between">
                <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
              </div>
            </ng-template>
            <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex">
                <div class="flex-grow-1 title-container"></div>
                <div class="pagination-container">
                  <p id="lblShowDetails">&nbsp;&nbsp; Show &nbsp;&nbsp;</p>
                  <kendo-pager-page-sizes [pageSizes]="pageSizes" id="ddlRecordsperPage">
                    of
                  </kendo-pager-page-sizes>
                  <span> &nbsp;&nbsp;Items&nbsp;&nbsp; </span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
                </div>
                <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true">
                    <!-- [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons" -->
                  </i>
                  <div class="d-none d-md-flex align-items-md-center">
                    <div class="icon-wrap">
                      <div class="file-excel-btn-dwd" kendoGridExcelCommand>
                        <i class="fa fa-file-excel-download-o cursor-pointer" aria-hidden="true" id="ibtExcelImport"
                          title="Excel Download" style="margin-left: 0px !important"></i>
                      </div>
                    </div>
                    <div class="icon-wrap">
                      <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                      <span class="list-icon-name">Filter</span>
                    </div>
                    <div class="icon-wrap">
                      <span class="list-icon-name">Grid Settings</span>
                    </div>
                    <div class="icon-wrap">
                      <i class="fa" [ngClass]="enableFullscreen ? 'fa-compress' : ' fa-expand'" aria-hidden="true"
                        title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}" (click)="toggleFullscreen()"></i>
                      <span class="list-icon-name">
                        {{ !enableFullscreen ? "Expand" : "Collapse" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <kendo-grid-column title="Sl.No." filterable="false" [width]="40">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ rowIndex + 1 }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Project Brief" [width]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ dataItem.project_code }} - {{ dataItem.project_desc}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Sgmt.Head(DDGH)" field="seg_head" [width]="30">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ dataItem.seg_head}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Peer Review Date" field="review_date" [width]="40">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ dataItem.review_date}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total Comments(L1+L2+L3)" field="total_comments" [width]="30">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ dataItem.total_comments}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column-group title="Comments Category">
              <ng-container>
                <kendo-grid-column title="L1" field="l1" [width]="20"></kendo-grid-column>
                <kendo-grid-column title="L2" field="l2" [width]="20"></kendo-grid-column>
                <kendo-grid-column title="L3" field="l3" [width]="20"></kendo-grid-column>
              </ng-container>
            </kendo-grid-column-group>
            <kendo-grid-column title="Project Response Status(Closed/Open)" field="PRStatus" [width]="40">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ dataItem.review_closed ? 'Completed':'Pending'}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Impact Status(Closed/Open)" field="ImplactStatus" [width]="20">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{ dataItem.review_closed ? 'Completed':'Pending'}}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel fileName="PAF Details.xlsx" [fetchData]="excelData"></kendo-grid-excel>
          </kendo-grid>
        </div>
      </div>
    </div>
  </div>
</div>